<template>
  <div class="d-flex p-4 rounded-3" card="actual">
    <div class="pe-4">
      <div class="pe-2">
        <i :class="icon"></i>
      </div>
    </div>
    <div class="d-flex flex-column align-items-start">
      <h4 card="title" class="fw-bold">{{ title }}</h4>
      <h2
        class="fw-bold pb-2"
        style="line-height: 30px; color: black"
        :style="
          smallfont
            ? {
                fontSize: '24px',
                lineHeight: '18px',
              }
            : {}
        "
      >
        {{ value }}
      </h2>
      <div class="d-flex flex-column align-items-start">
        <slot name="details"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatCardComp",
  props: {
    icon: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    value: {
      type: String,
      required: false,
    },
    smallfont: {
      type: Boolean,
      required: false,
    },
  },
};
</script>

<style scoped>
[card="actual"] {
  height: 150px;
  background-color: rgb(233, 233, 233);
  transition: 200ms ease all;
}
[card="actual"]:hover {
  transform: translateY(-4%);
}
[card="title"] {
  font-size: 14.4px;
  color: black !important;
}
[stat-detail] {
  font-size: 13px;
  line-height: 0px;
  color: rgb(102, 102, 102);
  font-weight: 500;
}
[stat-detail] span {
  color: black;
}
</style>
